import { Module } from 'vuex';
import { getters } from '@/store/holidays/getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AppState } from '../app';
import { HolidayViewModel } from '@/features/bots/models/holidayViewModel';

export interface HolidaysState {
  holidays: HolidayViewModel[];
}

// initial state
export const holidaysState: HolidaysState = {
  holidays: [],
};

export const holidays: Module<HolidaysState, AppState> = {
  namespaced: false,
  state: holidaysState,
  getters,
  actions,
  mutations,
};
